import React, { Component } from 'react';
import './index.scss';
import ReactEcharts from 'echarts-for-react'; 
class SviChartLine extends Component {
	constructor(params) {
		super(params);
		this.containerRef = React.createRef();
		this.state = {
			echartsOption: {},
			chartHeight: 450,
			defaultData: [
				{indicator_id: null, indicator_name: null, value: null, year: "2002"},
				{indicator_id: null, indicator_name: null, value: null, year: "2003"},
				{indicator_id: null, indicator_name: null, value: null, year: "2004"},
				{indicator_id: null, indicator_name: null, value: null, year: "2005"},
				{indicator_id: null, indicator_name: null, value: null, year: "2006"},
				{indicator_id: null, indicator_name: null, value: null, year: "2007"},
				{indicator_id: null, indicator_name: null, value: null, year: "2008"},
				{indicator_id: null, indicator_name: null, value: null, year: "2009"},
				{indicator_id: null, indicator_name: null, value: null, year: "2010"},
				{indicator_id: null, indicator_name: null, value: null, year: "2011"},
				{indicator_id: null, indicator_name: null, value: null, year: "2012"},
				{indicator_id: null, indicator_name: null, value: null, year: "2013"},
				{indicator_id: null, indicator_name: null, value: null, year: "2014"},
				{indicator_id: null, indicator_name: null, value: null, year: "2015"},
				{indicator_id: null, indicator_name: null, value: null, year: "2016"},
				{indicator_id: null, indicator_name: null, value: null, year: "2017"},
				{indicator_id: null, indicator_name: null, value: null, year: "2018"},,
				{indicator_id: null, indicator_name: null, value: null, year: "2019"},
				{indicator_id: null, indicator_name: null, value: null, year: "2020"}
			],
		};
	}

	componentDidMount() {
		this.handleLoadSviData();
	}
	componentDidUpdate(prevProps, prevState) {
		if (prevProps !== this.props) {
			this.handleLoadSviData();
			if (this.props.sviData.length === 0) {
				this.setState({
					isDataLoad: false
				})
			}
			else {
				this.setState({
					isDataLoad: true
				})
			}
		}
	}
	handleLoadSviData = () => {
		if (this.props.sviData) {
			let { sviData } = this.props;
			if(sviData.length === 0){
				sviData = this.state.defaultData
			}

			if (sviData.length !== 0) {
					let xAxisYears = [];
					const indicators = [];
					const dataSeries = [];

					sviData.forEach((item) => {
						if (xAxisYears.indexOf(item.year) === -1) {
							xAxisYears.push(item.year)
						}
						if (indicators.indexOf(item.indicator_name) === -1) {
							indicators.push(item.indicator_name)
						}
					});
					xAxisYears = xAxisYears.sort(function (a, b) {
						return Number(a) - Number(b)
					});

					indicators.forEach((indicator_name) => {
						const data = [];
						let name = '';
						sviData.forEach((item) => {
							if (indicator_name === item.indicator_name) {
								name = item.indicator_name;
								data.push([item.year, item.value]);
							}
						});
						dataSeries.push({
							type: 'line',
							name: name,
							data: data
						});
					});

					const values = [];
				sviData.forEach(item => item.value !== null && values.push(item.value));
				const max = Math.max(...values);
				const min = Math.min(...values);
				// const limit = Math.max(Math.max(Math.abs(100-max), Math.abs(100-min)), 1);

				// 動態估算 legend 高度，避免項目過多時 legend 疊進繪圖區
				const containerWidth = this.containerRef.current
					? this.containerRef.current.offsetWidth
					: 900;
				const longestName = indicators.reduce((m, n) => Math.max(m, (n || '').length), 0);
				const itemWidth = 25 + longestName * 14 + 20;
				const perRow = Math.max(1, Math.floor(containerWidth / itemWidth));
				const legendRows = Math.max(1, Math.ceil(indicators.length / perRow));
				const rowHeight = 24;
				const legendHeight = legendRows * rowHeight + 10;
				const chartHeight = 450 + Math.max(0, (legendRows - 1) * rowHeight);

					const option = {
						color: ['#68AAFF', '#2FC172', '#FDC100', '#FF6F6E', '#CDA374', '#FF0000', '#0000FF', '#7E57C2', '#CC5500', '#404040'],
						grid: {
							containLabel: true,
							left: '0%',
							right: '0%',
							top: legendHeight,
							bottom: '15%',
						},
						legend: {
							show: true,
							top: 0,
							data: indicators,
						},
						tooltip: {
							trigger: 'axis',
						},
						xAxis: {
							type: 'category',
							data: xAxisYears,
						axisLabel: { rotate: xAxisYears.length > 15 ? 45 : 0 }
						},
						yAxis: {
							type: 'value',
							minInterval: 2,
							splitNumber: 5,
							min: Math.floor(min-1), //100 - Math.floor(limit*1.5),
							max: Math.ceil(max+1), //100 + Math.ceil(limit*1.5),
							scale: true
						},
						series: dataSeries
					};
					this.setState({
						echartsOption: option,
						chartHeight,
					});
			}
		}
	}

	

	render() {
		const { className } = this.props;
		return (
			<div ref={this.containerRef} className={`line-chart ${className ? className : ''}`}>
				<ReactEcharts
					option={this.state.echartsOption}
					notMerge={true}
					lazyUpdate={true}
					opts={{ renderer: 'svg' }}
					style={
						{ height: this.state.chartHeight + 'px' }
					}
				/>
			</div>
		);
	}
}

export default SviChartLine;
